import { optionsESM } from '../index.js';

export default [optionsESM];
